import { NSMenuActionProps } from "namirasoft-site-react";
import { ContentTemplateRoutes } from "./ContentTemplateRoutes";

export class ContentTemplateMenus
{
	static make(getIDs: () => string[]): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Make & Send",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = ContentTemplateRoutes.Make(id);
				},
				showLoading: false
			}
		}
	}
}